// https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
export const hashFromString = (str: string) => {
  let hash = 0;
  let i, chr;
  for (i = 0; i < str.length; i += 1) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr; // eslint-disable-line
    // Convert to 32bit integer
    hash |= 0; // eslint-disable-line
  }
  return hash;
};

export const hasFromObject = (obj: Record<string, any>) => hashFromString(JSON.stringify(obj));
